<template>
	<div class="container">
		<!--<b style="margin-top:10px; margin-left:10px;">WO Number: {{joborderid}}</b>



		<layout-15
			:table_name="'Invoice Job Orders'"
			:id=pageid1
			:term=term
			:type=type
			:month=month
			:year=year
			:from=fromdate
			:to=todate
			:limit=limit
			:vessel=checkbox4
			:customer=checkbox5
			style="width:100%;"
		></layout-15>-->

		<div class="column">
			<div style="display:inline;">
		        <table style="width:calc(100% - 10px); margin-left:5px;">
					<tr>
						<td style="max-width:30px">
							<input style="max-width:20px" type="checkbox" v-model="checkbox1" v-on:click="selectCheckbox(1)"></input>
						</td>
						<td>
							<p class="gridname">ALL</p>
						</td>
						<td>
							<p class="gridname">LIMIT</p>
							<input class="gridinput" type="number" v-model="limit"></input>
						</td>
					</tr>
					<tr>
						<td style="max-width:30px">
							<input style="width:20px" type="checkbox" v-model="checkbox2" v-on:click="selectCheckbox(2)"></input>
						</td>
						<td style="width:50%">
							<p class="gridname">MONTH</p>
							<button style="width:30px; float:right;" v-on:click="changeMonth(-1)">></button>
							<button class="gridinput" style="width:calc(70% - 70px);">{{month}}</button>
							<button style="width:30px; float:right;"v-on:click="changeMonth(1)"><</button>
						</td>
						<td style="width:50%">
							<p class="gridname">YEAR</p>
							<input class="gridinput" type="number" v-model="year"></input>
						</td>
					</tr>
					<tr>
						<td style="max-width:30px">
							<input style="width:20px" type="checkbox" v-model="checkbox3" v-on:click="selectCheckbox(3)"></input>
						</td>
						<td>
							<p class="gridname">FROM</p>
							<input type="date" class="gridinput" v-model="fromdate"></input>
						</td>
						<td>
							<p class="gridname">TO</p>
							<input type="date" class="gridinput" v-model="todate"></input>
						</td>
					</tr>
				</table>

				<table style="width:calc(100% - 10px); margin-left:5px; margin-top:5px;">
					<tr>
						<td style="width:30px;">
							<input style="width:20px" type="checkbox" v-model="checkbox4" v-on:click=""></input>
						</td>
						<td>
							<p class="gridname">ONLY VESSEL</p>
						</td>
					</tr>
					<tr>
						<td style="width:30px;">
							<input style="width:20px" type="checkbox" v-model="checkbox5" v-on:click=""></input>
						</td>
						<td>
							<p class="gridname">ONLY CUSTOMER</p>
						</td>
					</tr>
				</table>

				<div style="width:calc(100% - 10px); margin-left:5px; margin-top:5px;">
					<button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
		    		<input v-model="search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
		            <button v-on:click="setRouter(true)" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
				</div>
			</div>

			<div class="scroll" style="width:calc(100% - 10px); height:calc(100vh - 340px); margin-left:5px; margin-top:5px;">
				<table v-if="column_names.length>0">
					<tr v-for="(column, col) in column_data">
						<td>
							<div style="width:100%; padding:5px;" :style="{'background':'#'+column[12]}">
								<input type="checkbox" style="width:20px; height:20px;"></input>
								<div class="outerdiv">
									<div class="innerdiv">
										<p>{{column[1]}}</p>
										<p>{{column[2]}}</p>
										<p>{{column[6]}}</p>
										<p>{{column[5]}}</p>
										<p>{{column[9]}}</p>
									</div>
									<div class="innerdiv">
										<p>{{column[3]}}</p>
										<p>{{column[7]}}</p>
										<p>{{column[4]}}</p>
										<p>{{column[8]}}</p>
									</div>
									<div class="innerdiv">
										<p>{{column[11]}}</p>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="column">

		</div>
		<div class="column">

		</div>

	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			search_term:'',
			limit:200,
			column_names: [],
			column_data:[],
			sort_value:[],
			loading:true,

			pageid1:PAGES.EDIT_INVOICE_PAGE,
			pageid2:PAGES.EDIT_INVOICE_PAGE_JOBORDER,

			checkbox1:true,
			checkbox2:false,
			checkbox3:false,
			checkbox4:false,
			checkbox5:false,

			type:0,
			fromdate:'',
			todate:'',
			limit:100,
			month:'October',
			year:2023,

			joborderid:'',

			monthsList:['January','February','March','April','May','June','July','August','September','October','November','December']
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.getWONumber();

		var getLimit = api.getCookie("limit_"+this.id)
		if(getLimit!=null && getLimit!=undefined) { this.limit = getLimit }

		this.search(true)
	},
	methods:{
		async clear (){
            this.search_term = "";
            this.setRouter(true);
        },
		async setRouter(full){
			this.search(full);
		},
		async search (full){
			var currentTerm = this.search_term;
			var timeout = /*full?0:*/500;

			document.cookie="limit_"+this.id+"="+this.limit+";";

			setTimeout(() => {
				this.loading=true;
				api.postData(
	                {
	                    type:"search",
	                    data:{
							pageid:this.pageid1,
							fullsearch:full,
							limit:this.limit,
							data:[
								this.search_term,
								this.term,
								this.type,
								this.month,
								this.year,
								this.fromdate,
								this.todate,
								this.limit,
								this.checkbox4,
								this.checkbox5,
		                    ],
							sort:this.sort_value,
						}
	                }
	            ).then((res) => {
					console.log(res.data)
					if(res.data.data!=null && res.data.data.column_data!=null){
			            this.column_names = res.data.data.column_names;
						this.column_data = res.data.data.column_data;

						for(var i = 0;i<this.column_data.length;i++){
							if(this.column_data[i][0]=='true'){
								this.column_data[i][0]=true;
							}else{
								this.column_data[i][0]=false;
							}
						}
					}
		        }).finally((res)=>{
					this.loading=false;
				});
			}, timeout);
		},
		getWONumber(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						data:[
							this.term,
						],
					}
				}
			).then((res) => {
				if(res.data != null && res.data.data.column_data!=null) {
					this.joborderid = res.data.data.column_data[0][0];
				}
			})
		},
		selectCheckbox(id) {
			this.checkbox1 = false
			this.checkbox2 = false
			this.checkbox3 = false
			switch (id) {
				case 1:
					this.checkbox1 = true
					this.type = 0
					break;
				case 2:
					this.checkbox2 = true
					this.type = 1
					break;
				case 3:
					this.checkbox3 = true
					this.type = 2
					break;
				default:
					break;
			}
		},
		changeMonth(amt) {
			let currentMonth = this.monthsList.indexOf(this.month);
			currentMonth -= amt;
			if (currentMonth<0) currentMonth = 11;
			if (currentMonth>=12) currentMonth = 0;
			this.month = this.monthsList[currentMonth];
		},
		back(){

		}
	}
}
</script>

<style>
.container {
	position:relative;
	max-width:100%;
	display: grid;
    align-content: space-evenly;
    grid-template-columns:repeat(3, minmax(0, 1fr));
    gap: 10px;
    height: calc(100vh - 60px);
    background-color: #2196F3;
    padding: 10px;
}

.column {
	background-color: rgba(255, 255, 255, 0.8);
	padding:5px 0;
	margin-top:10px;
	margin-bottom:10px;
	height:calc(100vh - 75px);
}

.gridname{
	float:left;
	margin-top:5px;
	margin-bottom:0px;
	text-align: left;
	width:30%;
}
.gridinput{
	float:right;
	margin-top:0px;
	margin-bottom:0px;
	width:70%;
	justify-content:
}

.outerdiv {
    display:flex;
    flex-direction:column;
}
.innerdiv {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
	border-top:1px solid gray;
}
.innerdiv>p{
	font-size:18px;
    margin-top:0px;
    margin-bottom:0px;
    margin-right:5px;
    margin-left:5px;
}

</style>


<!--
select
	CONCAT('11-',RIGHT(CONCAT('0000',a.joborderid),5)) WONumber,
    b.vesselname Vessel,
    c.portname Port,
    e.berthingside Side,
    d.jobtypename Type,
    e.orderdatetime Date,
    f.employeename Employee,
    g.customername Customer,
    a.status Status,
    h.localofficename LocalOffice,
    a.Comments,
    ( select group_concat( i.invoiceid SEPARATOR ', ' ) from oop_ldpa.invoicejoborders as i where i.joborderid = a.joborderid ) Invoiceid,
    ( select ifnull( sum( ( unix_timestamp(l.todatetime)-unix_timestamp(l.fromdatetime) )/3600*l.persons) ,0 ) from oop_ldpa.invpreptimes as l inner join oop_ldpa.invoiceprep as m on l.invoiceprepid = m.invoiceprepid where m.joborderid = a.joborderid ) -
    ( select ifnull( sum( ( unix_timestamp(j.todatetime)-unix_timestamp(j.fromdatetime) )/3600*j.persons) ,0 ) from oop_ldpa.invjobordertimes as j inner join oop_ldpa.invoicejoborders as k on j.invoicejoborderid = k.invoicejoborderid where k.joborderid = a.joborderid ) OpenHours,
    ifnull(( select group_concat( concat(n.qty,' x ',replace(n.description,',',' ')) SEPARATOR ', ' ) from oop_ldpa.invprepmaterial as n inner join oop_ldpa.invoiceprep as o on n.invoiceprepid = o.invoiceprepid where o.joborderid = a.joborderid ),'') Material
from
	oop_ldpa.joborders as a
    inner join oop_ldpa.vessels as b on a.vesselid = b.vesselid
    inner join oop_ldpa.ports as c on a.portid = c.portid
    inner join oop_ldpa.jobtypes as d on a.jobtypeid = d.jobtypeid
    inner join oop_ldpa.jobschedules as e on a.joborderid = e.joborderid
    inner join oop_ldpa.employees as f on e.employeeid = f.employeeid
    inner join oop_ldpa.customers as g on a.customerid = g.customerid
    inner join oop_ldpa.localoffice as h on c.localofficeid = h.localofficeid
where
	a.invoiced = 'No' and
    ( select count(invoiceid) from oop_ldpa.invoicejoborders as i where i.joborderid = a.joborderid ) > 2
group by a.joborderid
;
-->



// WEBPACK FOOTER //
// src/components/edit/Edit_Invoice.vue